import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';

const FarmManagementRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  // Show loader while checking authentication
  if (loading) {
    return <Loader />;
  }

  // If user is authenticated, redirect to their dashboard
  if (isAuthenticated && user) {
    const userRole = user.role?.toLowerCase();
    
    switch (userRole) {
      case 'expert':
        return <Navigate to="/expert-dashboard" replace />;
      case 'retailer':
        return <Navigate to="/retailer-dashboard" replace />;
      case 'farmer':
      default:
        return <Navigate to="/farmer-dashboard" replace />;
    }
  }

  // If not authenticated, show the farm management page
  return children;
};

export default FarmManagementRoute;

